"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_SOURCE = void 0;
var DATA_SOURCE = {
  NORWAY: 'norway',
  JAPAN: 'japan',
  UK: 'united_kingdom'
};
exports.DATA_SOURCE = DATA_SOURCE;
//# sourceMappingURL=data_source.enum.js.map